import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Diamond, Dribbble, Shield, CircleDot, Goal, Sparkles, Volleyball, Footprints, Shirt } from 'lucide-react';
import { Container } from '../Container';
import { motion } from 'framer-motion';
const SPORTS = [{
  name: 'Baseball',
  desc: 'Full button, two-button, v-neck, and pants.',
  path: '/sports/baseball',
  icon: Diamond
}, {
  name: 'Basketball',
  desc: 'Reversible jerseys, shorts, and shooter shirts.',
  path: '/sports/basketball',
  icon: Dribbble
}, {
  name: 'Football',
  desc: 'Durable game jerseys, practice gear, and pants.',
  path: '/sports/football',
  icon: Shield
}, {
  name: 'Softball',
  desc: 'Jerseys, pants, and custom team apparel.',
  path: '/sports/softball',
  icon: CircleDot
}, {
  name: 'Soccer',
  desc: 'Full kits, goalie gear, and warm-ups.',
  path: '/sports/soccer',
  icon: Goal
}, {
  name: 'Cheer',
  desc: 'Custom uniforms, warm-ups, and bags.',
  path: '/sports/cheer',
  icon: Sparkles
}, {
  name: 'Volleyball',
  desc: 'Long sleeve, short sleeve, and sleeveless options.',
  path: '/sports/volleyball',
  icon: Volleyball
}, {
  name: 'Track & Field',
  desc: 'Singlets, compression gear, and warm-ups.',
  path: '/sports/track-field',
  icon: Footprints
}, {
  name: 'Groupwear',
  desc: 'Corporate, staff, and organizational apparel.',
  path: '/sports/groupwear',
  icon: Shirt
}];
export function PickYourSport() {
  return <section className="py-20 bg-white" data-id="element-198">
      <Container data-id="element-199">
        <div className="text-center mb-12" data-id="element-200">
          <h2 className="font-oswald text-4xl md:text-5xl font-bold uppercase mb-4 text-gray-900" data-id="element-201">
            Pick Your Sport
          </h2>
          <div className="w-24 h-1.5 bg-pts-red mx-auto mb-6" data-id="element-202"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-203">
            Select your sport to view custom uniform options, team packages, and
            design inspiration.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.4
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-204">
          {SPORTS.map(sport => <Link key={sport.name} to={sport.path} className="group block bg-gray-50 border border-gray-200 rounded-lg p-6 hover:shadow-lg hover:-translate-y-1 hover:border-pts-red transition-all duration-300 relative overflow-hidden" data-id="element-205">
              <div className="absolute top-0 left-0 w-full h-1 bg-pts-red transform -translate-y-full group-hover:translate-y-0 transition-transform duration-300" data-id="element-206"></div>

              <div className="flex items-start justify-between mb-4" data-id="element-207">
                <h3 className="font-oswald text-2xl font-bold text-gray-900 uppercase tracking-wide" data-id="element-208">
                  {sport.name}
                </h3>
                <div className="bg-gray-200 group-hover:bg-pts-red group-hover:text-white p-2 rounded-full transition-colors duration-300 text-gray-700" data-id="element-209">
                  <sport.icon className="h-5 w-5" data-id="element-210" />
                </div>
              </div>

              <p className="text-gray-600 mb-6 min-h-[48px]" data-id="element-211">{sport.desc}</p>

              <div className="flex items-center text-pts-red font-bold text-sm uppercase tracking-wider group-hover:text-pts-red-dark" data-id="element-212">
                View Options{' '}
                <ArrowRight className="ml-2 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-213" />
              </div>
            </Link>)}
        </motion.div>
      </Container>
    </section>;
}